import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/income',
    meta: {
        title: 'Adequate income | Child Poverty',
    },
    title: 'Adequate income',
    intro: oneLine`<b>254,000</b> children in New Zealand currently live in low-income households. By 2028, the 
        Government has committed to reduce this number by <b>130,000</b>. Big, bold changes are needed to reach 
        this target.`,
    image: {
        filename: 'Income.png',
        alt: '',
    },
    content: [
        oneLine`<p>Low income households have disposable equivalised income less than 50% of the national median 
            income after housing costs.</p>`,
        oneLine`<p>One of the best ways to reduce the number of children in poverty is to raise family incomes by 
            increasing benefits and making the minimum wage a living wage.</p>`,
    ],
};

export default data;
